module.exports = __webpack_public_path__ + "img/sam4.fd4ede0f.jpg";